var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcPaymentFrequencies = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_payment_frequencies",
  transform: "translate(-445 12240)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_loan_portfolio_management",
  transform: "translate(-50 -12358)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_142",
  "data-name": "Rectangle 142",
  d: "M0,0H34V34H0Z",
  transform: "translate(495 118)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_1",
  "data-name": "Subtraction 1",
  d: "M-14.746,12336H-25a2,2,0,0,1-2-2v-16a2,2,0,0,1,2-2H-7a2,2,0,0,1,2,2v8.253a7.045,7.045,0,0,0-1-.581V12318a1,1,0,0,0-1-1H-25a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1h9.672a7.006,7.006,0,0,0,.58,1Z",
  transform: "translate(528 -12190)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_122",
  "data-name": "Rectangle 122",
  transform: "translate(505 123)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 6,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1,
  height: 5,
  rx: 0.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_125",
  "data-name": "Rectangle 125",
  transform: "translate(505 131)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1,
  height: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_132",
  "data-name": "Rectangle 132",
  transform: "translate(505 135)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1,
  height: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_136",
  "data-name": "Rectangle 136",
  transform: "translate(505 139)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1,
  height: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_126",
  "data-name": "Rectangle 126",
  transform: "translate(509 131)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1,
  height: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_131",
  "data-name": "Rectangle 131",
  transform: "translate(509 135)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1,
  height: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_135",
  "data-name": "Rectangle 135",
  transform: "translate(509 139)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1,
  height: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_127",
  "data-name": "Rectangle 127",
  transform: "translate(513 131)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1,
  height: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_128",
  "data-name": "Rectangle 128",
  transform: "translate(517 131)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1,
  height: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_123",
  "data-name": "Rectangle 123",
  transform: "translate(511 123)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 6,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1,
  height: 5,
  rx: 0.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_124",
  "data-name": "Rectangle 124",
  transform: "translate(517 123)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 6,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1,
  height: 5,
  rx: 0.5,
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_280",
  "data-name": "Group 280",
  transform: "translate(-21.518 -4.518)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_6",
  "data-name": "Ellipse 6",
  transform: "translate(484.518 -12217.482)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 6,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 5.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "_",
  "data-name": "$",
  d: "M3.527-4.546a.79.79,0,0,0-.221-.575A1.931,1.931,0,0,0,2.57-5.53a5.791,5.791,0,0,1-.8-.337A1.63,1.63,0,0,1,.815-7.38,1.561,1.561,0,0,1,1.228-8.5a1.76,1.76,0,0,1,1.121-.519v-.892H3v.9a1.62,1.62,0,0,1,1.1.6,2.066,2.066,0,0,1,.389,1.3H3.5a1.289,1.289,0,0,0-.231-.812.754.754,0,0,0-.628-.3A.848.848,0,0,0,2.03-8a.807.807,0,0,0-.221.609.763.763,0,0,0,.219.571,2.129,2.129,0,0,0,.742.407,6.275,6.275,0,0,1,.822.356,2.1,2.1,0,0,1,.5.374A1.487,1.487,0,0,1,4.41-5.2a1.711,1.711,0,0,1,.11.642A1.528,1.528,0,0,1,4.1-3.433a1.863,1.863,0,0,1-1.18.507v.8h-.65v-.794A1.87,1.87,0,0,1,1.022-3.5,1.887,1.887,0,0,1,.586-4.8H1.58a1.135,1.135,0,0,0,.26.8.948.948,0,0,0,.734.282,1.01,1.01,0,0,0,.71-.225A.774.774,0,0,0,3.527-4.546Z",
  transform: "translate(487.964 -12205.464)",
  fill: "#fff"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcPaymentFrequencies);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_payment_frequencies.6d2953aa90ea4d3bb086a1ea37fd40d8.svg";